// UI
const resourcesFilter = document.getElementById('resources-filter')
const filterToggleBtn = document.getElementById('resources-filter-toggle')
const header = document.getElementById('masthead-blog')
const closeFilterButton = document.querySelector('.js-close-filter')
const applyFilterButton = document.querySelector('.apply-filters-button')

const filterCheckboxes = Array.from(document.querySelectorAll('.filter-container input[type=checkbox]'))

const submitButtons = Array.from(document.querySelectorAll('.search-box-container button[type="submit"'))

let selectedFilters = []

let filterOpen = false

const filterSet = [
	{
		param: 'segment',
		selector: '[data-filterType="marketSegment"]'
	},
	{
		param: 'type',
		selector: '[data-filterType="mediaType"]'
	},
	{
		param: 'topic',
		selector: '[data-filterType="resourceTopic"]'
	},
]

if (filterToggleBtn) {
	filterToggleBtn.addEventListener('click', () => {
		toggleFilter()
	})
	
	
	closeFilterButton.addEventListener('click', () => {
		closeFilter()
	})
	
	applyFilterButton.addEventListener('click', () => {
		applyFilters()
	})
}


const toggleFilter = () => {
	filterOpen = !filterOpen
	if (filterOpen) {
		header.classList.add('filterOpen')
	} else {
		header.classList.remove('filterOpen')
	}
}

const closeFilter = () => {
	filterOpen = false;
	header.classList.remove('filterOpen')

}


const applyFilters = () => {
	let filterURL = '/resources/?' + buildFilterParamsURL()
	document.location.href = filterURL;
}


const buildFilterParamsURL = () => {
	let filterURL = ''
	let firstParam = true
	filterSet.forEach((set, index) => {
		let selectedOptions = 
			Array.from(document.querySelectorAll(set.selector))
			.filter(input => input.checked === true)
		
		
		if (selectedOptions.length > 0) {
			if (firstParam === true) {
				filterURL += set.param + '='
				firstParam = false
			} else {
				filterURL += '&' + set.param + '='
			}
		}
		
		selectedOptions.forEach((input, index) => {
			filterURL += input.value
			if (index < selectedOptions.length-1)  filterURL += ','
		})
	})
	return filterURL
}


const buildFilterTagList = (e) => {
	
	const tagContainer = document.querySelector('.tag-list-container')
	tagContainer.innerHTML = ''
	const applyContainer = document.querySelector('.apply-container')
	
	let clearButton2 = applyContainer.querySelector('.clear-button')

	if (clearButton2) {
		applyContainer.removeChild(clearButton2)
	}

	const filteredInputs = filterCheckboxes.filter(input => input.checked === true)


	filteredInputs.forEach(input => {
		const span = document.createElement('span')
		span.classList.add('tag-button')
		span.dataset.value = input.value
		const node = document.createTextNode(input.nextElementSibling.textContent)
		const button = document.createElement('button')
		button.dataset.value = input.value
		const img = new Image()
		img.src = wpObj.theme_url + '/assets/images/ui/filter-close.svg'
		
		span.appendChild(node)
		button.appendChild(img)
		span.appendChild(button)
		tagContainer.appendChild(span)

		button.addEventListener('click', function(e) {
			const span = document.querySelector('span[data-value="'+ this.dataset.value + '"]')
			span.parentNode.removeChild(span)
			document.querySelector('input[value="'+ this.dataset.value + '"').checked = false
		})
	})
	
	if (filteredInputs.length > 0) {
		document.querySelector('#search-options input[value=filter]').checked = true
	} else {
		document.querySelector('#search-options input[value=all]').checked = true
	}

	if (filteredInputs.length > 1) {
		const clear = document.createElement('span')
		const clearButton = document.createElement('button')
		clearButton.classList.add('clear-button')
		clearButton.appendChild(document.createTextNode('Clear filters'))
		clear.appendChild(clearButton)
		tagContainer.appendChild(clear)

		clearButton2 = clearButton.cloneNode(true)
		applyContainer.appendChild(clearButton2)

		const clearBtnArr = [clearButton, clearButton2]

		clearBtnArr.forEach(btn => {
			btn.addEventListener('click', function() {
				tagContainer.innerHTML = ''
				applyContainer.removeChild(clearButton2)
				Array.from(document.querySelectorAll('.filter-container input[type=checkbox]')).forEach(input => {
					input.checked = false
				})
			})
		})
	
	}

}

if (filterCheckboxes) {
	filterCheckboxes.forEach(input => {
		input.addEventListener('change', buildFilterTagList)
	})
}

if (submitButtons) {
	submitButtons.forEach(submit => {
		submit.addEventListener('click', function() {
			const searchString = document.querySelector('.search-box-container input').value 
			console.log(searchString)
			const searchType = document.querySelector('input[type="radio"][name="searchBy"]:checked')
			console.log(searchType.value)
			if (searchString !== '') {
				let searchURL = '/resources/?s=' + searchString
				searchURL += '&m=' + searchType.value
				if (searchType.value === 'filter') searchURL += '&' + buildFilterParamsURL()
				document.location.href = searchURL
			}
		})
	})
}